import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
.then(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./ngsw-worker.js');
    console.log('Angular está em execução no modo de desenvolvimento. Ligue enableProdMode () para habilitar o modo de produção.');
  }
})
.catch(err => console.log(err));



// WEBPACK FOOTER //
// /usr/src/app/src/main.ts